import * as types from '../constants/actionTypes';

const initialState = {
  user: null,
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),
  loading: false,
  error: null,
  permissions: [], // Store permissions in Redux only
  // Additional state for new features
  resetToken: null,
  emailVerified: false,
  passwordResetSuccess: false,
  passwordChangeSuccess: false,
  verificationEmailSent: false
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_REQUEST:
    case types.SIGNUP_REQUEST:
    case types.FORGOT_PASSWORD_REQUEST:
    case types.RESET_PASSWORD_REQUEST:
    case types.CHANGE_PASSWORD_REQUEST:
    case types.VERIFY_EMAIL_REQUEST:
    case types.RESEND_VERIFICATION_REQUEST:
    case types.GET_PROFILE_REQUEST:
    case types.UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.LOGIN_SUCCESS:
      // Only store token in localStorage for session persistence
      localStorage.setItem('token', action.payload.token);
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        loading: false,
        error: null,
        // Store permissions in Redux only - NO localStorage
        permissions: Array.isArray(action.payload.permissions) ? action.payload.permissions : []
      };

    case types.SIGNUP_SUCCESS:
      // Handle token if provided during signup
      if (action.payload.token) {
        localStorage.setItem('token', action.payload.token);
        return {
          ...state,
          user: action.payload.user,
          token: action.payload.token,
          isAuthenticated: true,
          loading: false,
          error: null
        };
      }
      return {
        ...state,
        loading: false,
        error: null
      };

    case types.LOGIN_FAILURE:
    case types.SIGNUP_FAILURE:
    case types.FORGOT_PASSWORD_FAILURE:
    case types.RESET_PASSWORD_FAILURE:
    case types.CHANGE_PASSWORD_FAILURE:
    case types.VERIFY_EMAIL_FAILURE:
    case types.RESEND_VERIFICATION_FAILURE:
    case types.GET_PROFILE_FAILURE:
    case types.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case types.LOGOUT:
      // Only clear token from localStorage
      localStorage.removeItem('token');
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        error: null,
        permissions: [] // Clear permissions from Redux
      };

    case types.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case types.SET_ERROR:
      return {
        ...state,
        error: action.payload
      };

    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null
      };

    // Forgot Password Success
    case types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        resetToken: action.payload.token || null
      };

    // Reset Password Success
    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        passwordResetSuccess: true,
        resetToken: null
      };

    // Change Password Success
    case types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        passwordChangeSuccess: true
      };

    // Email Verification Success
    case types.VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        emailVerified: true,
        user: action.payload.user || state.user
      };

    // Resend Verification Success
    case types.RESEND_VERIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        verificationEmailSent: true
      };

    // Get Profile Success - Include permissions if provided
    case types.GET_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        user: action.payload.user,
        // Update permissions if provided in profile response
        permissions: action.payload.permissions
          ? (Array.isArray(action.payload.permissions) ? action.payload.permissions : state.permissions)
          : state.permissions
      };

    // Update Profile Success
    case types.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        user: action.payload.user
      };

    // Set Permissions - Store in Redux only
    case types.SET_PERMISSIONS:
      return {
        ...state,
        permissions: Array.isArray(action.payload) ? action.payload : []
      };

    // Clear Permissions - Clear from Redux only
    case types.CLEAR_PERMISSIONS:
      return {
        ...state,
        permissions: []
      };

    default:
      return state;
  }
};

export default authReducer;